export default "__VITE_ASSET__5ce4f242__"